import type { ReactNode } from "react";
import { Redirect } from "wouter";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Loader } from "@threadws/jute";

/** Renders its children only when signed in; otherwise sends you to /sign-in. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useKindeAuth();
  if (isLoading) return <Loader label="Checking your session" />;
  if (!isAuthenticated) return <Redirect to="/sign-in" replace />;
  return children;
}
